import { getKeys } from 'shared/lib/object';

import type { OnboardingModel } from '../model';

import { stepsMap } from './constants';

export function getProgressBarSections(steps: OnboardingModel['steps']) {
  const filteredOptional = getKeys(steps).filter((keyStep) => !stepsMap[keyStep].optional);

  return filteredOptional.map((keyStep) => steps[keyStep] === 'done').sort((a, b) => Number(b) - Number(a));
}
